import { bgcolor, palette } from '@procurify/ui-theme'
import { rem, shade } from 'polished'
import styled, { css } from 'styled-components'

import { Icon } from '../../Icon'
import { type ITagProps } from '../Tag'

export const TagStyled = styled.div<ITagProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${(props) => props.theme.typography.pxToRem(80)};
  padding: ${(props) => props.theme.typography.pxToRem(8)}
    ${(props) => props.theme.typography.pxToRem(16)};

  line-height: ${(props) => props.theme.typography.pxToRem(16)};
  vertical-align: middle;
  color: ${(props) =>
    props.theme.colors[props.color] || props.theme.colors.text.primary};
  background-color: ${(props) =>
    props.theme.colors[props.color] || props.theme.colors.lightGrey};
  border-radius: ${(props) => props.theme.typography.pxToRem(16)};
  > ${Icon.Styled} {
    margin-left: ${(props) => rem(props.theme.spacing() * 0.625)};
    font-size: ${(props) => props.theme.typography.pxToRem(12)};
    vertical-align: middle;
    flex-shrink: 0;
  }

  ${(props) => (!props.fullWidth ? 'max-width: 15.75em;' : '')};
  ${palette};

  ${(props) => {
    if (props.onClick) {
      const bgColor =
        bgcolor(props)?.backgroundColor ||
        props.theme.colors[props.color] ||
        props.theme.colors.lightGrey

      return css`
        cursor: pointer;

        &:hover {
          background-color: ${shade(0.1, bgColor)};
        }
      `
    }
  }}
`
